import React, { memo, useMemo } from 'react';
import styled from 'styled-components';

import RadioDisabledBlankIcon from '@/ui/Icons/RadioDisabledBlankIcon';
import RadioDisabledCheckIcon from '@/ui/Icons/RadioDisabledCheckIcon';
import RadioEnabledIcon from '@/ui/Icons/RadioEnabledCheckIcon';
import RadioFocusedIcon from '@/ui/Icons/RadioFocusedCheckIcon';
import RadioFocusedBlankIcon from '../Icons/RadioFocusedBlankIcon';
import RadioEnabledBlankIcon from '../Icons/RadioEnabledBlankIcon';

interface RadioBoxProps {
  isChecked?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  label?: React.ReactNode;
  /**
   * focused된 아이콘 fill 속성
   */
  focusedFill?: string;
  /**
   * enabled된 아이콘 fill 속성
   */
  enabledFill?: string;
  boxSize?: string;
  radioType?: 'arrow' | 'blank';
}

const RadioBox = ({
  isChecked = false,
  disabled = false,
  onClick,
  label,
  focusedFill,
  enabledFill,
  boxSize,
  radioType = 'arrow',
  ...props
}: RadioBoxProps) => {
  const onClickRadioBox = () => {
    if (!disabled) {
      onClick && onClick();
    }
  };

  const RadioBoxRender = useMemo(() => {
    switch (radioType) {
      case 'arrow': {
        if (disabled) {
          return isChecked ? (
            <RadioDisabledCheckIcon {...{ boxSize }} />
          ) : (
            <RadioDisabledBlankIcon {...{ boxSize }} />
          );
        } else {
          return isChecked ? (
            <RadioFocusedIcon {...{ boxSize, fill: focusedFill }} />
          ) : (
            <RadioEnabledIcon {...{ boxSize, fill: enabledFill }} />
          );
        }
      }

      case 'blank': {
        if (disabled) {
          return isChecked ? (
            <RadioDisabledCheckIcon {...{ boxSize }} />
          ) : (
            <RadioDisabledBlankIcon {...{ boxSize }} />
          );
        } else {
          return isChecked ? (
            <RadioFocusedBlankIcon {...{ boxSize, fill: focusedFill }} />
          ) : (
            <RadioEnabledBlankIcon {...{ boxSize, fill: enabledFill }} />
          );
        }
      }

      default:
        return <></>;
    }
  }, [boxSize, isChecked, disabled, enabledFill, focusedFill, radioType]);

  return (
    <Wrapper onClick={onClickRadioBox} disabled={disabled} {...props}>
      {RadioBoxRender}

      {label}
    </Wrapper>
  );
};

export default memo(RadioBox);

const Wrapper = styled.div<{ disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;
